import makeApiCall from "../master/axiosIndex";

const DashboardApis = {
  workOrderSummary: () =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/work-order-summary`,
    }),
  WorkOrderStatus: () =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/work-order-status`,
    }),
  TopWorkCategories: () =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/top-work-categories`,
    }),
  TopContractorsbyWorkOrders: () =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/top-contractors`,
    }),
  BudgetVariancebyContractor: () =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/budget-variance-by-contractor`,
    }),
  WorkExecutionMonitoring: () =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/work-execution-monitor`,
    }),
  PendingExecutionApprovals: () =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/pending-execution-approvals`,
    }),
  ContractorSummary: () =>
    makeApiCall({
      method: "get",
      url: `/dashboard-reports/contract-summary`,
    }),
};

export default DashboardApis;
